<template>
  <v-container fluid>
    <base-material-card color="primary" icon="mdi-file-arrow-up-down" inline class="ml-0 px-5 py-4">
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">Modelos de Cadernos de Serviços</div>
      </template>

      <v-btn
        id="btn-novo-modelo-caderno-servicos"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float: left"
        relative
        text
        medium
        @click="openDialogDownloadArquivo = true"
      >
        <v-icon left size="30px">mdi-plus-circle</v-icon>
        NOVO MODELO
      </v-btn>

      <v-text-field
        id="modelo-caderno-servicos-historico-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search bs-caderno-servicos ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px"
      />

      <general-progress-bars class="mt-11" :items="downloadProgressData" prefixText="Baixando Modelo de Caderno de Serviços" />

      <v-divider class="mt-10" />

      <v-data-table
        class="modelo-caderno-servicos-table"
        :headers="headers"
        :items="items"
        :search.sync="search"
        :loading="loadingItems"
        no-data-text="Nenhum caderno de serviços disponível"
        no-results-text="Nenhum registro correspondente encontrado"
        :headerProps="{ sortByText: 'Ordenar Por' }"
        :footer-props="{ itemsPerPageText: 'Itens por Página' }"
        mobile-breakpoint="800"
      >
        <template v-slot:[`item.id`]="{ item }">{{ item.id }}</template>
        <template v-slot:[`item.nome`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div class="text-truncate-column" v-bind="attrs" @click="openDialogAcompanhamento(item)" v-on="on">
                {{ item.nome }}
              </div>
            </template>
            <span>{{ item.nome }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.usuario`]="{ item }">{{ item.usuario }}</template>
        <template v-slot:[`item.executado`]="{ item }">{{ item.executado }}</template>
        <template v-slot:[`item.status`]="{ item }">
          <general-status :status="item.status" />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            v-if="item.status === 'SUCESSO'"
            id="action-download-modelo-caderno-servicos"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            :loading="downloadProgressData[item.id] !== undefined ? true : false"
            @click="downloadItem(item)"
          >
            <v-icon small>mdi-download</v-icon>
          </v-btn>

          <v-menu v-if="canRunItem(item)" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                id="action-more-caderno-servicos"
                color="white"
                class="ml-1"
                height="22px"
                width="22px"
                fab
                x-small
                elevation="1"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="executarItem(item.id)">
                <v-list-item-icon class="mx-0 my-0 py-4">
                  <v-icon small>mdi-play</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Executar</v-list-item-title>
              </v-list-item>
              <v-list-item @click="openDialogDetalhes(item)">
                <v-list-item-icon class="mx-0 my-0 py-4">
                  <v-icon small>mdi-file-find-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Detalhes</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </base-material-card>

    <dialog-download-arquivo :openDialog.sync="openDialogDownloadArquivo" @created="$emit('rechargeTable')" />

    <general-dialog-detalhes
      ref="dialogDetalhes"
      title="Parâmetros do Modelo"
      :show-dialog="dialogDetalhes"
      @changeValue="dialogDetalhes = $event"
    >
      <template slot="body">
        <v-data-table
          :headers="dialogDetalhesHeader"
          :items="dialogDetalhesData"
          hide-default-footer
          class="elevation-1 style-table-dialog-detalhes"
          disable-pagination
          mobile-breakpoint="10"
        >
          <template v-slot:item="row">
            <tr>
              <td class="button" width="210px">
                {{ row.item.parametro }}
              </td>
              <td v-if="row.item.isTextarea" class="button" style="padding-left: 0px !important">
                <v-textarea rows="5" no-resize readonly class="ml-4 mt-0 pt-0" :value="row.item.valor" />
              </td>
              <td v-else class="button">
                {{ row.item.valor }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>
    </general-dialog-detalhes>
  </v-container>
</template>

<script>
  import ModelosCadernosServicosService from '@/services/parametrosComCa/ModelosCadernosServicosService';
  import powerupsActionsMixins from '@/mixins/powerupsActionsMixins.js';

  export default {
    name: 'ModelosCadernosServicosDataTable',

    components: {
      GeneralProgressBars: () => import('@/components/general/GeneralProgressBars.vue'),
      DialogDownloadArquivo: () => import('@/components/parametrosComCa/cadernosServicos/DialogDownloadArquivo.vue'),
      GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
      GeneralDialogDetalhes: () => import('@/components/general/GeneralDialogDetalhes')
    },

    mixins: [powerupsActionsMixins],

    props: {
      items: {
        type: Array,
        required: true
      },
      loadingItems: {
        type: Boolean,
        default: false
      }
    },

    emits: ['rechargeTable'],

    data() {
      return {
        powerupService: ModelosCadernosServicosService,
        powerupEntityName: 'Modelo de Caderno de Serviços',
        search: '',
        headers: [
          {
            text: '#',
            value: 'id'
          },
          {
            text: 'Nome',
            value: 'nome'
          },
          {
            text: 'Usuário',
            value: 'usuario'
          },
          {
            text: 'Executado',
            value: 'executado'
          },
          {
            text: 'Status',
            value: 'status'
          },
          {
            sortable: false,
            text: 'Ações',
            value: 'actions',
            class: 'pl-4'
          }
        ],
        openDialogDownloadArquivo: false
      };
    },

    methods: {
      openDialogDetalhes(item) {
        this.dialogDetalhesData = [
          {
            parametro: 'ID',
            valor: item.id
          },
          {
            parametro: 'Nome',
            valor: item.nome
          },
          {
            parametro: 'Usuário',
            valor: item.usuario
          },
          {
            parametro: 'Executado',
            valor: item.executado
          },
          {
            parametro: `Obras ${item.obraNaoPertence ? ' (não pertence)' : ''}`,
            valor: item.obras.join('\n'),
            isTextarea: true
          },
          {
            parametro: `Tipologias ${item.tipologiaNaoPertence ? ' (não pertence)' : ''}`,
            valor: item.tipologias.join('\n'),
            isTextarea: true
          },
          {
            parametro: 'Data Inicial',
            valor: item.dataInicial
          },
          {
            parametro: 'Data Final',
            valor: item.dataFinal
          }
        ];
        this.dialogDetalhes = true;
      }
    }
  };
</script>

<style></style>
